import React, { useState } from "react"
import { useMutation } from "@apollo/react-hooks"
import ConfirmCancelModal from "./confirmCancelModal"
import withApolloClient from "../withApolloClient"
import { adjustCartMutationGQL } from "../gql/cart"
import { navigate } from "gatsby"

const BranchConfirmModal = ({
  open,
  handleClose,
  handleSubmit,
  branchName,
}) => {
  const [openDialog, setOpenDialog] = useState(false)
  const [adjustCart, { loading }] = useMutation(adjustCartMutationGQL, {
    onCompleted: res => {
      if (res.adjustCart) {
        handleClose()
        // setOpenDialog(true)
        return
      }
      navigate("/cart")
    },
  })

  return (
    <>
      {/* <ConfirmCancelModal
        showModal={openDialog}
        modalOverlay={"transparent"}
        title={"Alert"}
        message={<>Out of stock items will be removed from your cart.</>}
        onConfirm={() => navigate("/cart")}
        okText={"Done"}
        onCancel={() => setOpenDialog(false)}
      /> */}
      <ConfirmCancelModal
        modalOverlay={"transparent"}
        showModal={open}
        closeModal={handleClose}
        title={`${branchName}`}
        message={
          <>
            {/* Are you sure you want to change your shopping branch? */}
            {/* <br />
            <br /> */}
            {/* The items in your cart will be updated based on the branch's
            availability. */}
            Changing your shopping branch will update the cart items based on the branch's inventory.
            <br />
            <br />
            Sold out items will be removed from your cart.
            <br />
            <br />
            <br />
            Are you sure you want to change?
          </>
        }
        onConfirm={() => {
          handleSubmit()
          adjustCart()
        }}
        onCancel={handleClose}
        okText={loading ? "Loading..." : "Confirm"}
      />
    </>
  )
}

export default withApolloClient(BranchConfirmModal, {
  client: "cartClient",
})
